export default {
    errorsRootKey: 'VoiceAudios',
    resource: 'VoiceAudios',
    actions: ['index', 'show', 'create', 'update', 'destroy']
  }
  